import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {ChangeAuthor, ChangeSet} from "../order-history.model";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'change-label',
    templateUrl: './change-label.template.html',
    styleUrls: ['./change-label.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChangeLabelComponent implements OnInit {

	@Input() visible: boolean;
	@Input() changeSet: ChangeSet;

	authorToTextMap: { [key: string]: string } = {};

	constructor(private translateService: TranslateService) {
	}

	ngOnInit(): void {
		this.authorToTextMap[ChangeAuthor.CLIENT] = this.translateService.instant("change-label-component.client-change");
		this.authorToTextMap[ChangeAuthor.APPLICATION_REVIEWER] = this.translateService.instant("change-label-component.application-reviewer-change");
		this.authorToTextMap[ChangeAuthor.CLIENT_SERVICE] = this.translateService.instant("change-label-component.client-service-change");
	}

	changeBoxCssClass(): string {
		return this.changeSet.author.toLowerCase().replace('_', '-');
	}

	changedText(): string {
		return this.authorToTextMap[this.changeSet.author];
	}
}
